export default __webpack_public_path__ + "static/media/office1.d70458a5.png";